import MessageContent from '@sendbird/uikit-react/ui/MessageContent';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { debounce } from '_helpers/common';
import { selectCurrentMessage } from '_store/chat/selector';

import { getClassName } from './helpers';

// eslint-disable-next-line react/prop-types
const CustomMessageContent = ({ className, ...restProps }) => {
  const currentMessage = useSelector(selectCurrentMessage);
  const selectedSearchMessageClassName =
    currentMessage?.messageId === restProps?.message?.messageId &&
    currentMessage?.createdAt === restProps?.message?.createdAt
      ? 'selected-search-message'
      : [];

  useEffect(() => {
    if (currentMessage) {
      debounce(() => {
        const section = document.querySelector('.selected-search-message');

        if (section) {
          section.style.scrollMarginTop = '50px';
          section?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      })();
    }
  }, [currentMessage]);

  return <MessageContent {...restProps} className={getClassName([className, selectedSearchMessageClassName])} />;
};

export default CustomMessageContent;
